import { render, staticRenderFns } from "./topic-class.vue?vue&type=template&id=4a6ea3f1&"
import script from "./topic-class.vue?vue&type=script&lang=js&"
export * from "./topic-class.vue?vue&type=script&lang=js&"
import style0 from "./topic-class.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports